import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AppState } from '../../types/app-state';
import { AuthState } from '../../types/auth-state';
interface ProtectedRouteProps extends RouteProps {
	isAdmin?: boolean;
	adminOnly?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
	children,
	component: Component,
	adminOnly,
	...rest
}) => {
	const { token, sysadmin: isAdmin } = useSelector<
		AppState,
		Partial<AuthState>
	>((state) => state.auth);
	const isAuthenticated = !!token;

	const valid = () => {
		return (
			<Route
				{...rest}
				render={(props) => (Component && <Component {...props} />) || children}
			/>
		);
	};

	const invalid = () => {
		return (
			<Route
				{...rest}
				render={(props) => (
					<Redirect
						to={{
							pathname: '/login',
							state: { from: props.location },
						}}
					/>
				)}
			/>
		);
	};

	if (isAuthenticated) {
		if (adminOnly) {
			return isAdmin ? valid() : invalid();
		} else {
			return valid();
		}
	}

	return invalid();
};
